import SearchInput from "../../../components/inputs/searchInput";
import { useFormik } from "formik";
import SearchSelect from "../../../components/select/searchSelect";
import { useOptions } from "../../../components/hooks/useOptionsHook";

const SearchVacations = ({ t }) => {
  const formik = useFormik({ initialValues: {} });
  const { employeesStatusOptions } = useOptions();

  return (
    <section className="flex flex-wrap items-center justify-between gap-3 my-4 mt-8 md:flex-nowrap">
      <div className="flex flex-wrap items-center w-full gap-3 md:w-1/3 md:flex-nowrap">
        <SearchInput
          formik={formik}
          name={"search"}
          placeholder={t("searchWithNameOrDepartment")}
        />
      </div>
      <div>
        <SearchSelect
          options={employeesStatusOptions}
          formik={formik}
          name={"status"}
          placeholder={t("status")}
        />
      </div>
    </section>
  );
};

export default SearchVacations;
